import axiosClient from "../api/axiosClient";
import {message, notification} from "antd";

const mimeTypeToExtension: Record<string, string> = {
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
    'application/pdf': '.pdf',
};

const downloadSpreadsheet = async (fileId: string, fileName: string, mimeType: string) => {
    const hideLoading = message.loading('Downloading file...', 0);
    try {

        const file = await axiosClient.portal.get(`/api/files/download/spreadsheet/${fileId}`, {
            responseType: 'blob'
        });

        const contentType = (file.headers['content-type'] || '').split(';')[0].trim();
        const extension = mimeTypeToExtension[contentType] || '';
        const hasExtension = fileName.includes('.');
        const downloadedFileName = hasExtension ? fileName : fileName + extension;

        const url = window.URL.createObjectURL(new Blob([file.data]));
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', downloadedFileName);
        document.body.appendChild(link);

        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        hideLoading();
        message.success('File downloaded successfully');
    } catch (error) {
        hideLoading();
        console.error('Error downloading file:', error);
        // Handle the error, e.g., show a notification to the user
        notification.error({ message: 'Error downloading file' });
    }
}

export default downloadSpreadsheet;